export default {
	info: 'Informace ke zpětné vazbě',
	confirmHeader: 'Chcete uložit vybranou zpětnou vazbu?',
	confirmHeaderPossibleCP: 'Zadejte číslo sjednané smlouvy',
	policyNo: 'Číslo PS',
	save: 'Uložit',
	cancel: 'Zrušit',
};
